<div class="dropdown-divs">
  <!-- src/app/dropdown/dropdown.component.html -->
  <div class="display-div">
    <!-- <div>Snapshot Types: </div> -->
    <div (click)="openTypeDropdown($event)" class="dd">
      <p style="padding-left: 7%; display: flex; align-items: center; padding-left: 7%;">
        {{typeHeader}}</p>
      <!-- <div class="downarrow" style="font-weight: bold;"></div> -->
      <img src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg" alt="" class="icon">
    </div>
    <div *ngIf="typeDropdownPopup" class="a" DocumentClick (DocumentClicked)="closeTypeDropdown()">
      <div *ngFor="let item of snapshotTypes" class="dropdown-values"
        [ngClass]="{'selectedDropdownItem': item.selected}" (click)="onTypeClick(item)">
        <div style="padding-top:3%"><input type="radio" name="type" [value]="item.value" [checked]="item.selected"
            class="inputValues">
        </div>
        <div class="itemData" title="{{item.name}}">{{item.name}}</div>
      </div>
    </div>

  </div>


  <div class="widget-items section-block disabled">
    <input #sectionInput class="widget-input" title="{{selectedSection}}" (blur)="onSectionInputBlur()" maxlength="45"
      (click)="onSectionChange($event,false)" (focus)="onSectionFocus($event)" (input)="onSectionChange($event,true)" [(ngModel)]="selectedSection"
      type="text" placeholder="Section" (ngModelChange)="onSectionInputChange($event)">
  <button *ngIf="!sectionInputFocused && selectedSection && selectedSection.length>0" type="button" class="clear-icon" title="Clear"
      aria-label="Clear section" (mousedown)="$event.preventDefault()"  (click)="onSectionChange($event,false)">
      <img src="../../../../assets/images/common/Icon_Cross.svg" alt="Clear" />
    </button>
    <div class="data-items-container-section"
      *ngIf="sectionList!=undefined && sectionList!=null && sectionList.length>0  && sectionDropdownPopup">
      <div class="data-items" title="{{opt}}" *ngFor="let opt of sectionList" (click)="onSectionDropdownClick(opt)"
        [ngStyle]="{'display': selectedSection.length>0?(opt.name.toLowerCase().includes(selectedSection.toLowerCase()) ? 'flex' : 'none'):'flex'}">
        <!-- <div style="padding-top:3%"><input type="radio" name="type" [value]="opt.value" [checked]="opt.selected"
            class="inputValues">
        </div> -->
        <div class="itemData" title="{{opt.name}}">{{opt.name}}</div>
        <div class="deletesubsection"><img src="../../../../assets/images/common/trashicon.svg" alt=""
            class="deleteicon" (click)="deleteSectionConfirmation(opt)"></div>
      </div>
    </div>
  </div>

  <div class="widget-items subsection-block disabled">
    <!-- <input class="widget-input" title="{{selectedSubSection}}" (blur)="onSectionInputBlur()"
      (click)="onSubSectionChange($event,false)" (input)="onSubSectionChange($event,true)" [(ngModel)]="selectedSubSection"
      type="text" placeholder="Sub Section"> -->
    <div (click)="onSubSectionDropdownClick($event)" class="dd">
      <div class="subsectiontext">{{subSectionHeader}}</div>
      <!-- <div class="downarrow" style="font-weight: bold;"></div> -->
      <img src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg" alt="" class="icon">
    </div>
    <div class="b" DocumentClick (DocumentClicked)="closeSubsectionDropdown()">
      <div class="data-items-container" *ngIf="subSectionDropdownPopup">
        <div class="data-items addSubsection" (click)="addSubsection()"
          [ngClass]="subsectionList.length>=3?'disabled':''">
          <div><img src="../../../../assets/images/common/Add.svg" alt="" class="addicon"></div>
          <div>Add Sub Section</div>
        </div>
        <div class="data-items" title="{{opt}}" *ngFor="let opt of subsectionList" (click)="onSubSectionChange(opt)"
          [ngClass]="opt.selected?'selectedDropdownItem':''">
          <!-- [ngStyle]="{'display': opt.toLowerCase().includes(selectedSubSection.toLowerCase()) ? 'block' : 'none'}" -->
          <div style="padding-top:3%"><input type="radio" name="type" [value]="opt.value" [checked]="opt.selected"
              class="inputValues">
          </div>
          <div class="itemData" title="{{opt.name}}">{{opt.name}}</div>
          <div class="deletesubsection"><img src="../../../../assets/images/common/trashicon.svg" alt=""
              class="deleteicon" (click)="deletesubsectionConfirmation(opt)"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="display-div">
      <div (click)="openSectionDropdown($event)" class="dd" [ngClass]="{'disabled': sectionDisable}">
          <p style="padding-top: 2.5%;padding-left: 7%;">{{sectionHeader}}</p>
          <img src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg" alt="" class="icon">
      </div>
      <div *ngIf="sectionDropdownPopup" class="b" DocumentClick
          (DocumentClicked)="closeSectionDropdown()">
          <div *ngFor="let item of sections" class="dropdown-values"
              [ngClass]="{'selectedDropdownItem': item.selected}" (click)="onSectionClick(item)">
              <div style="padding-top:3%"><input type="radio" name="section" [value]="item.value"
                      [checked]="item.selected" class="inputValues">
              </div>
              <div class="itemData" title="{{item.name}}">{{item.name}}</div>
          </div>
      </div>

  </div>

  <div class="display-div">
      <div (click)="openSubsectionDropdown($event)" class="dd"
          [ngClass]="{'disabled': subSectionDisable}">
          <p style="padding-top: 2.5%;padding-left: 7%;">{{subSectionHeader}}</p>
          <img src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg" alt="" class="icon">
      </div>
      <div *ngIf="subSectionDropdownPopup" class="c" DocumentClick
          (DocumentClicked)="closeSubsectionDropdown()">
          <div *ngFor="let item of subSections" class="dropdown-values"
              [ngClass]="{'selectedDropdownItem': item.selected}" (click)="onSubsectionClick(item)">
              <div style="padding-top:3%"><input type="radio" name="subSection" [value]="item.value"
                      [checked]="item.selected" class="inputValues">
              </div>
              <div class="itemData" title="{{item.name}}">{{item.name}}</div>
          </div>
      </div>

  </div>  -->

</div>

<div class="chart-selection-container disabled" *ngIf="selectedSnapshotType!=undefined">
  <div class="chart_container">
    <div class="chart_left_container">
      <app-left-panel-widget-library *ngIf="!carouselView" [availableCharts]="availableCharts" [gotData]="gotData"
        [chartId]="chartId" [chartDisplayName]="chartDisplayName"
        (onChartClick)="goToChartSelection($event)"></app-left-panel-widget-library>


      <div class="available-charts-tiles" *ngIf="!carouselView">
        <div class="scroll-container">
          <div class="tiles-container">
            <div class="row" *ngFor="let chunk of chunkedCharts">
              <div class="tile" *ngFor="let chartSelection of chunk" [style]="!chartSelection.isEnabled?'width:0 !important;min-width:0 !important':''">
                <div [ngClass]="chartSelection.imgClassName" *ngIf="chartSelection.isEnabled"
                  style="cursor: pointer;transition:0.3s ease" (click)="exploreClick(chartSelection)">
                  <div class="chartsection-block">
                      <div
                        [ngClass]="chartSelection.chartSelectedNumber == 0 || chartSelection.chartSelectedNumber == undefined ? 'chart-numbers DN' : 'chart-numbers'">
                        {{chartSelection.chartSelectedNumber}}</div>
                  </div>
                  <div class="chart-txt-conatiner-tiles"><span class="chart-txt">{{chartSelection.chartTitle}}</span>
                  </div>
                  <div class="chart-btn-conatiner-tiles">
                    <div class="btn-container-tiles" (click)="exploreClick(chartSelection)"><span
                        class="btn-txt-tiles">Customize</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="chart_right_container">
      <app-visual-select [widgetList]="widgetList" [show]="true" (newWidgetList)="newListfromVisualSelect($event)"
        (duplicateWidgetAdded)="duplicateWidgetAdded($event)" (editClicked)="editWidget($event)"></app-visual-select>

    </div>
  </div>
  <!-- <div class="available-charts-carousel" *ngIf="carouselView">
    <div class="bucket-container" [@rotate]="centerIndex" *ngIf="carouselView">
      <div *ngFor="let bucket of bucketsToShow; let i = index;" class="bucket"
        [@rotate]="bucket.chartId === currentBucketId ? 'selected' : ''">
        <div class={{bucket.imgClassName}} [ngClass]="bucket.chartId === currentBucketId ? 'selected':''"
          [style]="bucket.chartId === currentBucketId ?'cursor: pointer;':''"
          (click)="(bucket.chartId === currentBucketId ?exploreClick(bucket):exploreClick(''))"></div>
        <div class="chart-txt-conatiner"
          [ngClass]="bucket.chartId === currentBucketId ? 'selectedchart-txt-conatiner':''"><span class="chart-txt"
            [ngClass]="bucket.chartId === currentBucketId ? 'selectedchart-txt':''">{{bucket.chartTitle}}</span></div>
        <div class="chart-btn-conatiner"
          [ngClass]="bucket.chartId === currentBucketId ? 'selectedchart-btn-conatiner':''">
          <div class="btn-container" [ngClass]="bucket.chartId === currentBucketId ? 'selectedbtn-container':''"
            (click)="exploreClick(bucket)"><span class="btn-txt"
              [ngClass]="bucket.chartId === currentBucketId ? 'selectedbtn-txt':''">Explore</span></div>
        </div>
      </div>
    </div>
    <div class="navigation" *ngIf="carouselView">
      <div class="navDiv">
        <div class="nav-item" id="prev" (click)="prev()" [class.disabled]="availableChartForSelection.length < 2">
        </div>
        <div class="current-page">{{ currentBucketId + '/' + availableChartForSelection.length }}</div>
        <div class="nav-item" id="next" (click)="next()" [class.disabled]="availableChartForSelection.length < 2">
        </div>
      </div>
    </div>
  </div> -->
  <div class="action-buttons">
    <div class="layout-button" [ngClass]="{disabled:widgetList.length==0}" (click)="LayoutClicked()">
      <img src="../../../../assets/images/common/Icon_load.svg" alt="Layout">
      <span class="btn-text">Layout</span>
    </div>
    <div class="preview-button"  [ngClass]="{disabled: !showPreview || widgetList.length == 0 }" (click)="redirecToPreviewPage()">
      <img src="../../../../assets/ImagesSnapshot/Public/Preview.svg" alt="Preview">
      <span class="btn-text">Preview</span>
    </div>
    <div class="save-button" [ngClass]="{disabled:widgetList.length==0}" (click)="SaveClicked()">
      <img src="../../../../assets/images/common/Icon_Save.svg" alt="Save">
      <span class="btn-text">Save</span>
    </div>

    <div class="download-fom" [ngClass]="{disabled:widgetList.length==0}" (click)="toggleDownloadDropdown($event)">
      <img src="../../../../assets/images/common/download-color-icon.svg" alt="Download FOM">
      <span class="btn-text">FOM Download</span>
      <div class="fom-dropdown" *ngIf="downloadDropdownOpen">
        <div class="fom-dropdown-item" (click)="$event.stopPropagation(); downloadLatestFOM($event)" [ngClass]="{ disabled: !separateFomExists }">
          <span>Latest FOM</span>
        </div>
        <div class="fom-dropdown-item" (click)="$event.stopPropagation(); downloadMasterFOM($event)">
          <span>Master FOM</span>
        </div>
      </div>
    </div>

    <div class="upload-fom" [ngClass]="{'disabled': widgetList.length == 0, 'separate-fom-exists': separateFomExists}" (click)="UploadFOMClicked()"
      [title]="'Only keep those rows which should not be displayed in the respective Client - Snapshot Name - Snapshot Type - Section - Sub-section'">
      <img src="../../../../assets/images/common/Upload.svg" alt="Upload FOM">
      <span class="btn-text">Upload FOM</span>
    </div>

    <input type="file" #fomFileInput style="display:none" (change)="onFomFilesSelected($event)" accept=".xls,.xlsx"/>
  </div>
</div>

<app-shared-popup-snapshot *ngIf="showErrorPopUp" [showErrorPopUp]="showErrorPopUp"
  [errorheaderTitle]="errorheaderTitle" [popUpMessage]="popUpMessage"
  (closeErrorPopUp)="onCloseIconClick($event)"></app-shared-popup-snapshot>

<app-shared-popup-snapshot *ngIf="showSubsectionPopup" [popUpParameter]="errorheaderTitle" [popUpMessage]="popUpMessage"
  (closeSubsectionPopUp)="onSubsectionPopupCloseIconClick($event)"></app-shared-popup-snapshot>

<div *ngIf="layoutPopup">
  <div class="overlay"></div>
  <app-layout-preview (dataEvent)="collapseLayout($event)" [objectFromPreview]="objectFromLayout"
    (enablePreview)="EnablingDisablingPreview($event)" (previewEnable)="EnablePreviewOnAdd($event)"
    [visualSelectedList]="widgetList" [SnapshotType]="typeHeader" [audienceCohortType]="audienceCohortType"></app-layout-preview>
</div>


<div *ngIf="showDeletePopup">
  <div class="overlay"></div>
  <app-delete-popup [message]="deletemessage" [flag]="true"
    (dataEvent)="receivedDeleteConfirmation($event)"></app-delete-popup>
</div>